/**
 * Display formatting helpers for the group booking system.
 */

/**
 * Booking options available in the system.
 */
export const BOOKING_OPTIONS = [
  { value: "no_camel", label: "No camel" },
  { value: "no_quad", label: "No quad" },
  { value: "swimming", label: "Swimming" },
  { value: "ticket_swimming", label: "Ticket Swimming" },
];

/**
 * Subset of booking options related to swimming.
 */
export const SWIMMING_OPTIONS = ["swimming", "ticket_swimming"];

/**
 * Formats a booking amount for display.
 * Returns "Xdh" for valid integer amounts between 1 and 999999,
 * or an empty string for invalid/missing amounts.
 *
 * @param {*} amount - The amount to format
 * @returns {string} Formatted amount string (e.g., "150dh") or empty string
 */
export function formatAmount(amount) {
  if (amount === null || amount === undefined || amount === "") {
    return "";
  }
  const n = parseInt(amount, 10);
  if (!Number.isInteger(n) || n < 1 || n > 999999 || String(n) !== String(Number(amount))) {
    return "";
  }
  return `${n}dh`;
}

/**
 * Formats a booking option for badge display.
 * Shows quantity prefix when quantity > 1 (e.g., "2 × Ticket Swimming"),
 * otherwise just the label.
 *
 * @param {{ label: string, quantity: number }} option - The booking option object
 * @returns {string} Formatted badge text
 */
export function formatOptionBadge(option) {
  if (!option || !option.label) {
    return "";
  }
  const quantity = parseInt(option.quantity, 10);
  if (quantity > 1) {
    return `${quantity} × ${option.label}`;
  }
  return option.label;
}
